define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/datatables_behavior"
], function($, _, Marionette, DatatablesBehavior){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        behaviors: {
            datatables: {
                behaviorClass: DatatablesBehavior
            }
        },

        ui: {},

        regions: {

        },

        initialize: function(){

            this.bindUIElements();

            // We init the datatable
            this.triggerMethod('init:table', {
                url: '/rest_payout/fee_cover',
                order: [[ 0, "desc" ]],
                columns: [
                    {
                        'name':'mt4_account_no',
                        'data':'mt4_account_no'
                    },
                    {
                        'name':'name',
                        'data':'name'
                    },
                    {
                        'name':'effective_deposit',
                        'data':'effective_deposit'

                    },
                    {
                        'name':'fee_covered',
                        'data':'fee_covered'
                    },
                    {
                        'name':'req_lot',
                        'data':'req_lot'
                    },
                    {
                        'name':'traded_lot',
                        'data':'traded_lot'
                    },
                    {
                        'name':'remaining_lot',
                        'data':'remaining_lot'
                    },
                    {
                        'name':'withdrawable_no_fee',
                        'data':'withdrawable_no_fee'
                    }
                ]
            });
        }

    });
});
